<template>
  <div class="Bannera">
    <div class="Banner_content">
      <div class="Banner_content_test">
        <p :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']" style="lineHeight:34px">{{$t('Reports.Reports')}}</p>
        <div
          class="test"
           :class="[language == 'zh'?'zhFamily':'enfamily']"
           style="lineHeight:22px"
        >{{$t('Reports.Description')}}</div>
      </div>
      <div class="Banner_content_img">
          <img src="../../../assets/image/SdgsReports/element.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.Bannera {
  width: 100%;
   margin-top: 70px;
  min-height: 300px;
  position: relative;
  object-fit: cover;
  background: url("../../../assets/image/SdgsReports/reports_banner.png") no-repeat;
  background-size: 100% 100%;

  .Banner_content {
    width: 1200px;
     margin-top: 70px;
    // height: 300px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: center;

    .Banner_content_test {
      min-height: 300px;
      padding: 30px 0;
      width: 770px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        color: #fff;
        font-size: 32px;
        font-weight: 600;
      }
      .test {
        margin-top: 20px;
        color: #fff;
        font-size: 14px;
      }
    }
    .Banner_content_img{
        width: 341px;
        margin-top: 10px;
        img{
            width: 100%;
        }
    }
  }
}
</style>